export default __webpack_public_path__ + "static/media/logo-celg-white.f669d883.png";